// logger
import logger from 'shared/logger';

export const MODULE_IDENTIFIER = 'MFA';

export const onEventFailure = (error: Error, pageName: string) => {
  logger.error({
    MODULE: MODULE_IDENTIFIER,
    MESSAGE: `Data error in ${pageName}`,
    error,
  });
};
